module.exports = __webpack_public_path__ + "img/farming_29.eaeb7bf9.png";